import qs from 'qs';
import find from 'lodash/find';
import upperFirst from 'lodash/upperFirst';
import moment from  'moment';
import isEmpty from 'lodash/isEmpty';
import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';
import includes from 'lodash/includes';

const queryToGoals = (dataForGoalsQuery, row, filters, additionalParams = {}) => {
	if (!row) return null;

	const { currentQuery, selectedFilters = [], groupColumns } = dataForGoalsQuery;

	const { groupsFilters, groupsDateRanges } = getFromGroups(currentQuery, groupColumns, row);

	const query = {
		...currentQuery,
		date_range: isEmpty(groupsDateRanges) ? currentQuery.date_range : groupsDateRanges,
		filters: {
			...currentQuery.filters,
			...reduce(filters, (acc, filter) => ({
				...acc,
				[filter.name]: filter.values.map(entity => entity.value)
			}), {}),
			...(groupsFiltersToQueryData(groupsFilters))
		},
		...additionalParams
	};

	const entity = {
		filters: prepareEntityFilters([].concat(selectedFilters, filters), groupsFilters),
		date_range: query.date_range,
		currency: query.currency,
		groups: query.groups
	};

	return qs.stringify({ query, entity });
};

export const queryToGoalsForRegion = (dataForGoalsQuery, row, region) => {
	const filters = [getRegionFilter(region)];
	return queryToGoals(dataForGoalsQuery, row, filters, { groups: ['offer'] });
};

export const queryToGoalsWithStatuses = (dataForGoalsQuery, row, statusesIds, additionalParams) => {
	const filters = [
		getStatusesFilter(dataForGoalsQuery.conversionsStatuses, statusesIds)
	];
	return queryToGoals(dataForGoalsQuery, row, filters, additionalParams);
};

export const queryToGoalsByManual = (dataForGoalsQuery, row) => {
	const filters = [{
		name: 'approval_type',
		values: [{ value: 'manual', label: 'manual' }]
	}];
	return queryToGoals(dataForGoalsQuery, row, filters);
};

const getRegionFilter = (region) => {
	return {
		name: 'regions',
		values: [{ value: region, label: region }]
	};
};

const getStatusesFilter = (conversionsStatusesList, statusesIds) => {
	const values = conversionsStatusesList
		.filter(entity => find(statusesIds, id => id === entity.id))
		.map(entity => ({ value: entity.id, label: upperFirst(entity.text) }));

	return {
		name: 'statuses',
		values
	};
};

const getFromGroups = (
	currentQuery,
	groupColumns,
	row
) => {
	const filters = [];
	const date_range = {};

	currentQuery.groups.forEach(groupName => {
		const relationFilterName = groupColumns[groupName] && groupColumns[groupName].relationToFilter;

		if (relationFilterName && row[groupName]) {
			const values = getFilterValueFromCell(row[groupName]);
			values && filters.push({
				name: relationFilterName,
				values: getFilterValueFromCell(row[groupName])
			});
		}

		if (groupName === 'date' && !row.isTotal) {
			const date = moment(row.date).isValid() && moment(row.date).format('YYYY-MM-DD');
			if (date) {
				const dateStart = moment(date).hours(0).minutes(0).seconds(0).milliseconds(0);
				const dateEnd = moment(date).hours(23).minutes(59).seconds(59).milliseconds(999);
				date_range['start'] = dateStart.format('YYYY-MM-DD HH:mm:ss.SSS');
				date_range['end'] = dateEnd.format('YYYY-MM-DD HH:mm:ss.SSS');
			}
		}
		if (groupName === 'status_changed_at' && !row.isTotal) {
			filters.push({
				name: 'status_changed_at',
				values: [{label: row[groupName], value: row[groupName]}]
			});
		}

		const groupNamesWithoutId = ['region', 'referer_domain', 'referer_type'];

		if (includes(groupNamesWithoutId, groupName) && !row.isTotal) {
			const values = getFilterValueFromCell(row[groupName], true);
			values && filters.push({
				name: relationFilterName,
				values: getFilterValueFromCell(row[groupName], true)
			});
		}
	});

	return {
		groupsFilters: filters,
		groupsDateRanges: date_range
	};
};

const getFilterValueFromCell = (cell, skipParensCheck = false) => {
	if (typeof cell !== 'string') return null;

	let res;
	const parentIndex = cell.lastIndexOf('(');

	if (parentIndex !== -1) {
		let label = cell.substring(0, parentIndex) && cell.substring(0, parentIndex).trim();
		let value = cell.substring(parentIndex);
		value = value && value.replace('(', '').replace(')', '');
		res = [{ label, value }];
	}

	if (skipParensCheck) {
		res = [{ label: cell, value: cell }];
	}

	return res;
};

const groupsFiltersToQueryData = filters => {
	const res = {};

	filters && filters.forEach(filter => {
		res[filter.name] = filter.values.map(entity => entity.value);
	});

	return res;
};

const prepareEntityFilters = (filters, groupsFilters) => {
	const filtersGroupedByName = groupBy(filters, entity => entity.name);
	const groupsFiltersGroupedByName = groupBy(groupsFilters, entity => entity.name);

	const merge = {
		...filtersGroupedByName,
		...groupsFiltersGroupedByName
	};

	return Object.keys(merge).map(filterKey => merge[filterKey][0]);
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/shared/query-to-goals.js